<script>
  export default {
    props: {
      src: {
        type: String,
        required: true,
      },
    },
    computed: {
      iconPath() {
        return `${window.AppConfig.staticPath}images/icons.svg#icon-${this.src}`;
      },
    },
  };
</script>

<template>
  <svg>
    <use
      :xlink:href="iconPath"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    />
  </svg>
</template>
